import React from "react";
import * as styles from "../styles/video.module.scss";

const Video = (props) => {
  return (
    <section
      className={`${props.inner ? styles.inner : styles.fullPage} ${
        props.size === "half"
          ? styles.half
          : props.size === "three quarters"
          ? styles.threequarters
          : styles.full
      }`}
    >
      <div className="container">
        <h2>{props.title}</h2>

        <div className={styles.embedContainer}>
          <iframe
            title={props.title}
            src={
              /youtube/.test(props.link)
                ? `https://www.youtube.com/embed/${props.link.split("?v=")[1]}`
                : /vimeo/.test(props.link)
                ? `https://player.vimeo.com/video/${
                    props.link.split("vimeo.com/")[1]
                  }`
                : ""
            }
            frameBorder="0"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default Video;
